module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/JYkSGm/tc-custom/9781936535729.jpg?1724535314168",
      "alt": "This image is the cover for the book Night of the Living POTUS"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Night of the Living POTUS\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("HELL TO THE CHIEF"), _c('br'), _c('br'), _vm._v("All United States Presidents have the same lesson to learn, and they all learn it early on the first full morning of their respective Administrations."), _c('br'), _c('br'), _vm._v("They are all confronted with the horrific secret at the heart of the White House...the one that subjects them to a blood-soaked, savage battle for survival."), _c('br'), _c('br'), _vm._v("To commemorate the 2012 election season, Hugo, Nebula and Stoker Nominee Adam-Troy Castro presents a newly-updated edition of one of his all-time strangest short stories, a one-of-a-kind mixture of political satire and relentless zombie horror that pits a new President against a siege by...the Founding Fiends."), _c('br'), _c('br'), _vm._v("Will Democracy survive...and what will be left of it?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Adam-Troy Castro\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Adam-Troy Castro's fiction has won the Seiun and Philip K. Dick Awards, and received two nominations for the Hugo, three for the Stoker, and eight for the Nebula.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0